import _ from 'lodash';
import { getContrastRatio } from '@material-ui/core/styles';

import { PaletteColor } from '../types';

// WCAG AA minimum contrast: normal text, and large text (>= 18px, or >= 14px bold).
export const WCAG_AA_MIN_CONTRAST = 4.5;
export const WCAG_AA_LARGE_TEXT_MIN_CONTRAST = 3;

// Palette names resolve case-insensitively; any other CSS colour passes through unchanged.
export const resolvePaletteColor = (color: string): string =>
  _.find(PaletteColor, { name: _.toLower(color) })?.hex || color;

interface IContrastTextOptions {
  // Ordered by preference; the first one reaching minContrast wins.
  candidates?: PaletteColor[];
  minContrast?: number;
}

// Memoized per colour so a re-rendering fill logs once, not every paint.
const warnUnparseableColor = _.memoize((color: string, error: unknown) => {
  console.warn(`getContrastTextColor: can't parse background "${color}"; using the preferred text colour`, error);
});

// Text colour for `background` (palette name / hex / rgb / hsl): first candidate meeting minContrast, else the highest-contrast one.
export const getContrastTextColor = (
  background: string,
  { candidates = [PaletteColor.WHITE, PaletteColor.BLACK], minContrast = WCAG_AA_MIN_CONTRAST }: IContrastTextOptions = {}
): string => {
  const preferred = _.head(candidates) || PaletteColor.WHITE;
  try {
    const contrastOf = ({ hex }: PaletteColor) => getContrastRatio(hex, resolvePaletteColor(background));
    return (_.find(candidates, text => contrastOf(text) >= minContrast) || _.maxBy(candidates, contrastOf) || preferred).hex;
  } catch (error) {
    warnUnparseableColor(background, error);
    return preferred.hex;
  }
};
